<template>
	<div>
		<div
			id="expenseDetailModal"
			style="display: block"
			class="modal"
			role="dialog"
		>
			<div class="modal-backdrop" @click="$emit('close')"></div>
			<div class="modal-dialog">
				<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
				<div class="receipt-nav modal-content">
					<div
						class="modal-wrapper"
						v-for="(receipt, index) in expenseStack"
						:id="'receipt-' + index"
						:key="'receipt-' + index"
					>
						<div
							class="modal-header"
							:class="isScroll ? 'scroll-modal-header text-center' : ''"
							:style="'background: ' + categoryColors[receipt.icon]"
						>
							<div class="sectionLeft" @click="closeModal()">
								<div>
									<font-awesome-icon
										class="header-icon"
										:icon="['fas', 'chevron-left']"
									/>
								</div>
							</div>
							<div :class="isScroll ? 'scroll-title-section' : 'title-section'">
								<h4 :class="isScroll ? 'scroll-vendor-name' : 'vendor-name'">
									{{ receipt.VendorName }}
								</h4>
								<p :class="isScroll ? 'scroll-amount-badge' : 'amount-badge'">
									<span class="title-amount">
										<span v-if="receipt.CurrencyCode === 'USD'">
											{{
												toFormatedCurrency(
													receipt.Amount,
													receipt.CurrencySymbol
												)
											}}
										</span>
										<span v-else>
											{{
												toFormatedCurrency(
													receipt.CurrencyAmount,
													receipt.CurrencyCode
												)
											}}
										</span>
									</span>
									<b-badge
										v-if="receipt.Reimbursable == 1"
										class="le-badge title-badge"
										:class="isScroll ? 'scroll-title-badge' : ''"
									>
										Reimbursable
									</b-badge>
								</p>
								<span
									class="equivalentUSD"
									v-if="receipt.CurrencyCode !== 'USD' && !isScroll"
								>
									<span>USD </span>
									<span>{{ toFormatedCurrency(receipt.Amount, "$") }}</span>
								</span>
							</div>
							<div class="sectionRight">
								<div
									class="deleteSection"
									@click="
										showDeleteConfirm('receipt', () =>
											deleteReceipt(receipt.ReceiptId)
										)
									"
								>
									<font-awesome-icon
										:icon="['fas', 'trash']"
										class="iconFa header-icon"
									/>
								</div>
								<div
									class="editSection"
									@click="updateReceipt(receipt.ReceiptId)"
								>
									<font-awesome-icon
										:icon="['fas', 'edit']"
										class="iconFa header-icon"
									/>
								</div>
							</div>
						</div>

						<div
							id="modal-body"
							class="modal-body expensesList"
							:class="isScroll ? 'modal-body-scroll' : ''"
						>
							<div v-if="!receipt.loaded">
								<Skeleton :count="3" :height="'50px'" />
								<Skeleton :count="3" :height="'150px'" />
							</div>
							<div v-else>
								<div class="tableSection category-name-area">
									<div
										class="block expense category-expense"
										:class="'category' + receipt.icon"
									>
										<div class="icon">
											<div class="glyph"></div>
										</div>

										<div class="details">
											<div class="title vendor">Category</div>
											<div class="subtitle category">
												{{ receipt.CategoryName }}
											</div>
										</div>
									</div>
								</div>

								<div class="block expense date-area">
									<div class="icon date-wrapper-color">
										<b-img
											class="glyph-img"
											:src="dateIcon"
											rounded
											fluid
										></b-img>
									</div>

									<div class="details">
										<div class="title vendor">Date Added</div>
										<div class="subtitle category">
											{{ receipt.TransactionDate | moment("MMMM D, YYYY") }}
										</div>
									</div>
								</div>

								<div class="block expense project-name-area">
									<div class="icon project-wrapper-color">
										<b-img
											class="glyph-img"
											:src="projectIcon"
											rounded
											fluid
										></b-img>
									</div>

									<div class="details">
										<div class="title vendor">Project</div>
										<div class="subtitle category">
											{{ receipt.ProjectName }}
										</div>
									</div>
								</div>

								<div class="block expense payment-name-area">
									<div class="icon payment-wrapper-color">
										<div class="icon"></div>
									</div>

									<div class="details">
										<div class="title vendor">Payment Method</div>
										<div class="subtitle category">
											{{ receipt.PaymentType }}
										</div>
									</div>
								</div>

								<div class="block expense payer-name-area">
									<div class="icon payer-wrapper-color">
										<div class="icon"></div>
									</div>

									<div class="details">
										<div class="title vendor">Payer</div>
										<div class="subtitle category">
											{{ receipt.Payer }}
										</div>
									</div>
								</div>

								<div
									class="note expense"
									:class="'category' + receipt.CategoryName"
								>
									<div class="details">
										<div class="subtitle note-title">Notes</div>
										<div class="note-body">{{ receipt.Note }}</div>
									</div>
								</div>

								<a
									:href="
										'https://' +
											receipt.FileBucket +
											'.s3.amazonaws.com/' +
											receipt.UserId +
											'/' +
											receipt.FileName
									"
									download
									class="uploadImage"
								>
									<b-img
										v-if="receipt.FileName"
										:src="
											'https://' +
												receipt.FileBucket +
												'.s3.amazonaws.com/' +
												receipt.UserId +
												'/' +
												receipt.FileName
										"
										rounded
										fluid
										title="Click to download"
									></b-img>
								</a>

								<div class="moreSection" v-if="sameVendorReceipts.length > 0">
									<h4 class="moreReceipt">
										More From {{ receipt.VendorName }}
									</h4>
								</div>
								<div class="tableSection category-name-area">
									<div
										v-for="(relatedReceipt, index) in sameVendorReceipts"
										class="block expense category-expense"
										@click="addReceipt(relatedReceipt)"
										:class="'category' + relatedReceipt.icon"
										:key="index"
									>
										<div class="icon">
											<div class="glyph"></div>
										</div>

										<div class="details">
											<div class="title vendor">
												{{ relatedReceipt.VendorName }}
											</div>
											<div class="subtitle category">
												{{ relatedReceipt.CategoryName }}
											</div>
										</div>
										<div class="value">
											{{
												toFormatedCurrency(
													(relatedReceipt.Amount * 100) / 100,
													"$"
												)
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Edit
			v-if="editShow"
			id="expenseEdit"
			:receiptToPass="receiptToPass"
			@close="editShow = false"
		></Edit>
	</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Edit from "./ExpenseEdit.vue";
import dateIco from "../resources/images/icons/date.png";
import projectIco from "../resources/images/icons/project.png";
import paymentIco from "../resources/images/icon_payment_type/icon.png";
import payerIco from "../resources/images/icon_payer/icon.png";
import { Skeleton } from "vue-loading-skeleton";
import { mapState } from "vuex";

export default {
	name: "Detail",
	props: ["expenses", "userId", "expenseColor"],
	data() {
		return {
			isLoading: false,
			fullPage: false,
			detailShow: true,
			editShow: false,
			expenseStack: this.expenses,
			currentIndex: 0,
			sameVendorReceipts: [],
			receiptToPass: null,
			isScroll: false,
			dateIcon: dateIco,
			projectIcon: projectIco,
			paymentIcon: paymentIco,
			payerIcon: payerIco,
			nav: null
		};
	},
	computed: {
		...mapState(["activeExpense"]),
		currentReceipt: function() {
			return this.expenseStack[this.currentIndex];
		}
	},
	components: {
		Loading,
		Edit,
		Skeleton
	},

	mounted() {
		this.getDetail();
		this.nav = document.querySelector(".receipt-nav");
		document
			.querySelector(".modal-body")
			.addEventListener("scroll", this.handleScroll);
		window.addEventListener("resize", () => {
			const left = this.nav.clientWidth * this.currentIndex;
			this.nav.scrollTo({ top: 0, left, behavior: "auto" });
		});
	},
	methods: {
		handleScroll() {
			const modalBody = document.querySelector(".modal-body");
			if (modalBody.scrollTop > 0) {
				this.isScroll = true;
			} else {
				this.isScroll = false;
			}
		},
		addReceipt(relatedReceipt) {
			this.currentIndex++;
			this.expenseStack[this.currentIndex] = relatedReceipt;
			const modalBody = document.querySelector(".modal-body");
			modalBody.scrollTop = 0;
			this.scrollToCurrent();
			this.getDetail();
		},
		async getDetail() {
			try {
				const self = this;
				const { data } = await this.$axios.get(
					"/receipt?id=" + this.currentReceipt.ReceiptId,
					{
						crossdomain: true
					}
				);
				const expense = data.Receipt;
				expense.loaded = true;
				expense.icon = self.getCategoryIcon(data.Receipt.CategoryName);
				this.$set(self.expenseStack, self.currentIndex, data.Receipt);
				self.updateVendorReceipts();
			} catch (error) {
				return error;
			}
		},
		updateVendorReceipts() {
			this.sameVendorReceipts = _.filter(this.activeExpense, expense => {
				return (
					expense.VendorName == this.currentReceipt.VendorName &&
					expense.ReceiptId != this.currentReceipt.ReceiptId
				);
			});
		},
		async deleteReceipt(id) {
			try {
				this.isLoading = true;
				let params = { data: { id } };
				await this.$axios.delete("receipt", params, { crossdomain: true });
				this.closeModal();
				this.$store.dispatch("removeExpense", { id });
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
			}
		},
		redirect() {
			this.$router.push({ name: "expenses" });
		},
		updateReceipt(id) {
			this.receiptToPass = id;
			this.editShow = true;
		},
		closeModal() {
			if (this.currentIndex == 0) {
				const modalBody = document.querySelector(".modal-body");
				modalBody.removeEventListener("scroll", this.handleScroll);
				this.$emit("close");
			} else {
				this.currentIndex--;
				this.updateVendorReceipts();
				const left = this.nav.clientWidth * this.currentIndex;
				this.nav.scrollTo({ top: 0, left, behavior: "smooth" });
			}
		},
		async scrollToCurrent() {
			try {
				this.isLoading = true;
				await this.getDetail();
			} catch (error) {
				return error;
			} finally {
				const left = this.nav.clientWidth * this.currentIndex;
				this.nav.scrollTo({ top: 0, left, behavior: "smooth" });
				this.isLoading = false;
			}
		},
		updatedExpense(expense) {
			const index = _.findIndex(this.expenseStack, {
				ReceiptId: expense.ReceiptId
			});
			if (index > -1) {
				this.updateVendorReceipts();
				this.expenseStack[index] = expense;
			}
			this.editShow = false;
		}
	}
};
</script>
